import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolRating from '../../../types/rating'
import CreationToolUploadField from '../../../types/upload-field'
import RatingField from '../../form-fields/upload/rating'
import { CreationToolUploadContext } from '../manager'

const Rating = styled(RatingField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadRatingField = ({ className, field }: Props) => {
    const { rating, setRating } = useContext(CreationToolUploadContext)

    return (
        <Rating
            {...{
                className,
                field,
                defaultRating: CreationToolRating.normalize(rating),
                showInstructions: true,
                onChange: (type) => setRating(CreationToolRating.value(type)),
            }}
        />
    )
}

export default CreationUploadRatingField
